import { ButtonBase, Stack } from '@mui/material';
import { FunnelDays } from 'features/co-pilot/co-pilot.types';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const WorkDayItem: React.FC<{
  label: string;
  value: FunnelDays;
  active: boolean;
  disabled?: boolean;

  handleWorkDaysChange(newWorkDay: FunnelDays): () => void;
}> = ({ label, value, active, disabled, handleWorkDaysChange }) => {
  const { classes, cx } = useStyles();

  return (
    <ButtonBase
      className={cx(classes.workDay, active ? 'active' : null, disabled ? 'disabled' : null)}
      onClick={handleWorkDaysChange(value)}
      disableRipple={true}
      disabled={disabled}
    >
      {label}
    </ButtonBase>
  );
};

interface Props {
  workDays: FunnelDays[];
  disabled?: boolean;

  handleWorkDaysChange(value: FunnelDays): () => void;
}

const WorkDaysSelect: React.FC<Props> = ({ workDays, disabled, handleWorkDaysChange }) => {
  const { t } = useTranslation();

  const isActive = (value: FunnelDays) => {
    return workDays.includes(value);
  };

  return (
    <Stack gap={2} flexWrap={'wrap'}>
      <Stack direction={'row'} gap={0.5} flexWrap={'wrap'}>
        {_.map(FunnelDays, (day) => (
          <WorkDayItem
            key={day}
            label={t(day).substring(0, 2)}
            value={day}
            active={isActive(day)}
            disabled={disabled}
            handleWorkDaysChange={handleWorkDaysChange}
          />
        ))}
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  workDay: {
    border: `1px solid ${theme.palette.greys.light}`,
    borderRadius: '10px',
    backgroundColor: '#FFF',
    color: theme.palette.greys.light,
    fontSize: theme.typography.pxToRem(16),
    width: '60px',
    height: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      background: theme.palette.action.hover,
    },
    '&.active': {
      background: theme.palette.primary.main,
      border: `2px solid ${theme.palette.primary.main}`,
      color: '#FFF',
    },
    '&.disabled': {
      '&.active': {
        background: theme.palette.greys.lighter,
        color: '#FFF',
      },
    },
  },
}));

export default WorkDaysSelect;
